<template>
  <div class="wechat-callback">
    <p>授权处理中，请稍候...</p>
  </div>
</template>

<script>
export default {
  mounted() {
    // hash 前面的 query 用 location.search 获取
    const code = new URLSearchParams(window.location.search).get('code')
    const state = new URLSearchParams(window.location.search).get('state')
    console.warn('code===', code, 'state===', state)
    // alert('code', code)
    if (code && state) {
      this.handleWecomCallback({ code, state })
    } else {
      alert('未获取到code')
      this.$router.replace('/') // 没 code 跳登录页
    }
  },
  methods: {
    async handleWecomCallback(params) {
      try {
        const res = await this.$api.wechatCallback(params)
        const payload = (res && res.data) || res
        if (payload && payload.token) {
          // 保存 token 与用户信息
          window.localStorage.setItem('access-token', payload.token)
          this.$commitUserInfo(payload)
          // 成功跳首页
          this.$router.replace('/home')
        } else {
          console.error('授权失败', res)
          this.$router.replace('/')
        }
      } catch (e) {
        console.error('接口调用失败', e)
        this.$router.replace('/')
      }
    }
  }
}
</script>
